import React from 'react';
import { FilterControls } from './FilterControls';
import { StopTheClockButton } from './StopTheClockButton';

interface Props {
  isLoading: boolean;
  isDownloadInProgress: boolean;
  onHandleStopTheClockModalOpen: React.MouseEventHandler<HTMLButtonElement>;
}

const Filters: React.FC<Props> = (props) => {
  const { isLoading, isDownloadInProgress, onHandleStopTheClockModalOpen } = props;

  const disableStopTheClock = isDownloadInProgress || isLoading;

  return (
    <div className="w-full flex gap-4 items-start max-w-[800px] flex-wrap z-50">
      <FilterControls />
      <StopTheClockButton onClick={onHandleStopTheClockModalOpen} disabled={disableStopTheClock} />
    </div>
  );
};

export default Filters;
